import moment from "moment";
import DateRangePickerComponent from "../../../components/common/CustomDateRangePicker";
import { Button, FormControl, Grid, InputAdornment, MenuItem, Select, styled, TextField, Box, Paper, TableContainer, Table, TableBody, TableRow, TableCell, Pagination, Typography, IconButton, CircularProgress } from "@mui/material";
import DownloadIcon from '@mui/icons-material/Download';
import {useEffect, useState } from "react";
import ReportsTableHeader from "../report-table-header.component";
import { format } from "date-fns";
import UserActivitySkeleton from "../skeleton/user-activity-skeleton";
import ReportService from "../../../services/api/reports";
import ExportAlertNotificationDialog from "../../alert/export-alert-notification-dialog.component";
import CachedIcon from "@mui/icons-material/Cached";
import {useSnackbar} from "notistack";

const SmallSelect = styled(Select)(({ theme, fontColor }) => ({
    minWidth: 120,  // Adjust the width as needed
    height: 33,     // Adjust the height as needed
    fontSize: '0.875rem',  // Adjust the font size as needed
    '.MuiSvgIcon-root': {
        color: fontColor, // Change to your desired color
    },
    color: fontColor,
    backgroundColor: '#fff',
    border: "1px solid #7A78F7",
    "& .MuiInputBase-root": { height: 33, border: "1px solid #7A78F7", color: "#3333CFCE", backgroundColor: '#fff', width: 250, borderRadius: "5px" },
    "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
    "& .MuiSelect-select": {
        fontSize: 12,
        fontStyle: 'italic'
    },
    "& .MuiMenuItem-root": {
        fontSize: 12,
    },
    "& .Mui-selected": {
        fontSize: 12,
        fontStyle: 'italic'
    },


}));

const UserActivityFilterComponent = (props) => {

    const {headers, userActivityList, isLoadingUserActivity, getUserActivity, page, setPage, 
        emailList, getUserEmail, getModule, moduleList} = props;

    const {enqueueSnackbar} = useSnackbar();

    const [user_email, setUserEmail] = useState('');
    const [module, setModule] = useState("")
    const [action, setAction] = useState("")
    const [inputAction, setInputAction ] = useState("")
    const [isLoadingAlertNotification, setIsLoadingAlertNotification] = useState(false)
    const [reportID, setReportID] = useState(null)
    const [open, setOpen] = useState(false)

    const [startDate, setStartDate] = useState(moment().subtract(6, 'days').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));

    useEffect(() => {

        const start_date = startDate;
        const end_date = endDate;
        
        let report_type;

        if (user_email && module && action) {
            report_type = 8; // start_date + end_date + email + module + action
        } else if (user_email && module) {
            report_type = 5; // start_date + end_date + email + module
        } else if (user_email && action) {
            report_type = 6; // start_date + end_date + email + action
        } else if (module && action) {
            report_type = 7; // start_date + end_date + module + action
        } else if (user_email) {
            report_type = 2; // start_date + end_date + email
        } else if (module) {
            report_type = 3; // start_date + end_date + module
        } else if (action) {
            report_type = 4; // start_date + end_date + action
        } else {
            report_type = 1; // start_date + end_date (default)
        }
    
    
        const payload = {
            start_date: start_date,
            end_date: end_date,
            email: [user_email],
            module: [module],
            action: action,
            report_type: report_type
        };
    
        getUserActivity(payload);
    }, [startDate, endDate, user_email, action, module]);

    useEffect(()=>{ getUserEmail() },[])
    useEffect(()=>{ getModule() },[])


    const handleDateRangeChange = (newStartDate, newEndDate) => {
        setStartDate(newStartDate);
        setEndDate(newEndDate);
    }

    const handleClose = () =>{
        setOpen(false)
    }

    const handleChangeUserEmail = (event) => {
        setUserEmail(event.target.value)
    }

    const handleChangeModule = (event) => {
        setModule(event.target.value)
    }

    const handleSearchAction = (event) => {
        setInputAction(event.target.value)
    }


    const itemsPerPage = 100;

    // Calculate the total number of pages
    const totalPages = Math.ceil((userActivityList?.length || 0) / itemsPerPage);

    // Get the current items to display
    const currentItems = (userActivityList || []).slice((page - 1) * itemsPerPage, page * itemsPerPage);

    // Handler to change page
    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const keyPress = (e) => {
        if (e.keyCode == 13) {
            setAction(inputAction)
        }
    }

    const handleExport = () => {

        const start_date = startDate;
        const end_date = endDate;
        
        let report_type;

        if (user_email && module && action) {
            report_type = 8; // start_date + end_date + email + module + action
        } else if (user_email && module) {
            report_type = 5; // start_date + end_date + email + module
        } else if (user_email && action) {
            report_type = 6; // start_date + end_date + email + action
        } else if (module && action) {
            report_type = 7; // start_date + end_date + module + action
        } else if (user_email) {
            report_type = 2; // start_date + end_date + email
        } else if (module) {
            report_type = 3; // start_date + end_date + module
        } else if (action) {
            report_type = 4; // start_date + end_date + action
        } else {
            report_type = 1; // start_date + end_date (default)
        }
    
    
        const payload = {
            start_date: start_date,
            end_date: end_date,
            email: [user_email],
            module: [module],
            action: action,
            report_type: report_type
        };

        if (userActivityList?.length > 0) {
            setIsLoadingAlertNotification(true);

            ReportService.exportUserActivity(payload).then((res)=>{
                console.log('get export alert and notification res here', res)
                setIsLoadingAlertNotification(false)
                setReportID(res?.data?.data?.report_id)
                setOpen(true)
            }).catch(() => {
                setIsLoadingAlertNotification(false)
            })

        } else {
            enqueueSnackbar("No data to export", { 
                variant: "error",
                autoHideDuration: 3000
            });
        }
       
    }

    const handleClearFilters = (e) => {
        setUserEmail("");
        setModule("");
        setAction("");
        setInputAction("");
        setStartDate(moment().subtract(6, "days").format("YYYY-MM-DD"));
        setEndDate(moment().format("YYYY-MM-DD"));
    }
   

    return (
        <Box>
            <Grid container sx={{ justifyContent: "flex-end", alignItems: "center", mt: 3}}>
                <Grid item xs={2.5}>
                    <Button variant="contained" sx={{height: "33px", textTransform: "none", backgroundColor: "#5959D8", color: "#fff", "&:hover": {backgroundColor: "#5959D8", color: "#fff"}}}
                        startIcon={<CachedIcon />} onClick={(e) => handleClearFilters(e)}
                    >
                        Clear Filters
                    </Button>
                </Grid>

                <Grid item xs={9.5} sx={{ display: 'flex', justifyContent: "flex-end" }}>
                <FormControl sx={{ width: 250 }}>
                        <SmallSelect
                            value={user_email}
                            onChange={handleChangeUserEmail}
                            displayEmpty
                            fontColor={'#5d5ed8'}
                            startAdornment={
                                <InputAdornment position="start">
                                    <p style={{ fontSize: 12, margin: 0, color: "#3333CFCE", fontWeight: 'bold' }}>
                                        User Email:
                                    </p>
                                </InputAdornment>
                            }
                        >
                            <MenuItem value="" disabled sx={{ fontSize: 12 }}>
                                <em>Select User Email</em>
                            </MenuItem>
                            
                            {emailList?.map((list, index)=>{
                                return(
                                    <MenuItem key={index} value={list.user_email} sx={{ fontSize: 12 }}>
                                        {list.user_email}
                                    </MenuItem>
                                )
                            })}
                        </SmallSelect>
                    </FormControl>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <FormControl sx={{ width: 250 }}>
                        <SmallSelect
                            value={module}
                            onChange={handleChangeModule}
                            displayEmpty
                            fontColor={'#5d5ed8'}
                            startAdornment={
                                <InputAdornment position="start">
                                    <p style={{ fontSize: 12, margin: 0, color: "#3333CFCE", fontWeight: 'bold' }}>
                                        Module:
                                    </p>
                                </InputAdornment>
                            }
                        >
                            <MenuItem value="" disabled sx={{ fontSize: 12 }}>
                                <em>Select Module</em>
                            </MenuItem>
                            
                            {moduleList?.map((list, index)=>{
                                return(
                                    <MenuItem key={index} value={list.module} sx={{ fontSize: 12 }}>
                                        {list.module}
                                    </MenuItem>
                                )
                            })}
                        </SmallSelect>
                    </FormControl>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                   <TextField
                        sx={{
                            "& .MuiInputBase-root": { height: 33, border: "1px solid #7A78F7", color: "#3333CFCE", backgroundColor: '#fff', width: "auto", borderRadius: "5px" },
                            "& .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                            },
                        }}
                        variant="outlined"
                        autoComplete="off"
                        inputProps={{ style: { padding: "5px 12px 5px 0px", fontSize: 12, fontStyle: 'italic' }, border: "1px solid #7A78F7" }}
                        placeholder="Search Action"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <p style={{ fontWeight: 'bold', fontSize: 12, margin: 0, color: "#3333CFCE"}}>
                                        Action:
                                    </p>
                                </InputAdornment>
                            ),
                            // endAdornment: searchedGeneratedBy && (
                            //     <InputAdornment position="end">
                            //         <IconButton
                            //             size="small"
                            //             // onClick={(e) => handleClearInput(e)}
                            //         >
                            //             <ClearIcon sx={{color: "#3333CFCE", fontSize: 17}} />
                            //         </IconButton>
                            //     </InputAdornment>
                            // ),
                        }}
                        value={inputAction}
                        onChange={handleSearchAction}
                        onKeyDown={keyPress}
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <DateRangePickerComponent
                        initialStartDate={startDate}
                        initialEndDate={endDate}
                        ranges={{
                            "Last 7 Days": [moment().subtract(6, 'days'), moment()],
                            "This Month": [moment().startOf('month'), moment().endOf('month')],
                            "Last Month": [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                            "Last 90 Days": [moment().subtract(89, 'days'), moment()],
                        }}
                        onDateRangeChange={handleDateRangeChange}
                    />

                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <Button
                        onClick={handleExport}
                        variant="contained"
                        startIcon= {isLoadingAlertNotification ? <CircularProgress sx={{color:'white'}} size={11} /> : <DownloadIcon />}
                        sx={{ fontSize: 12, background: '#3333CFCE', color: '#fff', textTransform: 'none', "&:hover": {backgroundColor: "#5959D8", color: "#fff"}}}
                    >
                        {isLoadingAlertNotification ? "Exporting" : "Export"}
                    </Button>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Paper sx={{ width: '100%', overflow: 'hidden', mt: 3,  }}>
                    <TableContainer sx={{ border: "1px solid #3333cf54", borderRadius: 2, width: "100%", maxHeight: 600}}>
                        <Table stickyHeader sx={{ minWidth: 650 }}>
                            <ReportsTableHeader headers={headers} />
                            {isLoadingUserActivity ? 
                                <TableBody>
                                    <UserActivitySkeleton/>
                                </TableBody>
                            :
                            <TableBody>
                                    {currentItems?.map((label, index) => (
                                        <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row">
                                                {label.user_email || "N / A"}
                                            </TableCell>

                                            <TableCell component="th" scope="row">
                                                {label?.module}
                                            </TableCell>

                                            <TableCell component="th" scope="row">
                                                {label?.action}
                                            </TableCell>
                                            
                                            <TableCell component="th" scope="row">
                                                {label.user_type}
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                {label?.timestamp ? format(new Date(label?.timestamp), "PP"): "N / A"}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            }
                        </Table>
                        
                        {/* ERROR MESSAGE */}
                        {!isLoadingUserActivity && userActivityList?.length === 0 && <Box sx={{textAlign:'center', m: 2}}> <Typography sx={{color:'gray', fontSize: 12}}>No data available.</Typography></Box>}

                    </TableContainer>
                    {!isLoadingUserActivity ?
                        <Box display="flex" justifyContent="center" mt={2} mb={2}>
                            <Pagination
                                count={totalPages}
                                page={page}
                                onChange={handlePageChange}
                                sx={{
                                    "& .MuiPaginationItem-root.Mui-selected": {
                                        color: "#fff",
                                        backgroundColor: "#5959D8"
                                    }
                                }} 
                            />
                        </Box>
                    : null}
                </Paper>
            </Grid>
            {/* DIALOG */}
            <ExportAlertNotificationDialog open={open} reportID={reportID} handleClose={handleClose}/>
        </Box>
    )

}

export default UserActivityFilterComponent